<template>
  <select-box
    :items="options"
    :value="value"
    @input="v => $emit('input', v)"
    v-bind="$attrs"
    :data-testid="dataTestid"
  />
</template>

<i18n lang="yaml">
</i18n>

<script>
import { flyingInsectTypeOptions } from '@/libs/insectTypes';

import SelectBox from '@/components/atoms/SelectBox';

export default {
  name: 'insect-type-select-box',
  components: {
    SelectBox,
  },
  props: {
    value: {
      required: true,
    },
    nullOption: {
      type: String,
    },
    'data-testid': String,
  },
  computed: {
    options() {
      const result = [...flyingInsectTypeOptions(this.$i18n.locale)];

      if (this.nullOption) {
        result.unshift({ value: null, text: this.nullOption });
      }

      return result;
    },
  },
};
</script>

<style lang="sass" scoped>
  .select-box
    flex-grow: 0
    width: 250px
</style>
